"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyPlusShortcut = void 0;
const react_1 = __importDefault(require("react"));
// Imported libs
const react_2 = require("@chakra-ui/react");
const SankeyPlusShortcut = (t) => {
    return (react_1.default.createElement(react_2.Accordion, null,
        react_1.default.createElement(react_2.AccordionItem
        // eventKey='OSP'
        , null,
            react_1.default.createElement(react_2.AccordionButton, null,
                react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfig_entry' }, t('Menu.rcc_titre_OSP')),
                react_1.default.createElement(react_2.AccordionIcon, null)),
            react_1.default.createElement(react_2.AccordionPanel, null,
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_osp_cs_bold')),
                    t('Menu.rcc_osp_cs')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_osp_ctrl_czdt_bold')),
                    t('Menu.rcc_osp_ctrl_czdt')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_F7_bold')),
                    t('Menu.rcc_F7')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_F8_bold')),
                    t('Menu.rcc_F8')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, t('Menu.rcc_F9_bold')),
                    t('Menu.rcc_F9'))))));
};
exports.SankeyPlusShortcut = SankeyPlusShortcut;
